import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from "ngx-bootstrap";
import { INodeOptions } from "@app/workflow-common/diagram-view2/models/node.model";
import { WorkflowhttpService } from "@app/workflow-common/services/workflowhttp.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SidebarNavService } from "@app/shared/cs-components/sidebar-nav/services/sidebar-nav.service";
import { TranslateService } from "@ngx-translate/core";
import { WorkflowObservableService } from "@app/workflow-common/services/workflow-observable.service";
var AutomationSetupComponent = /** @class */ (function () {
    function AutomationSetupComponent(modalRef, _workflowService, sidebarNavService, translate, _workflowObservableService) {
        this.modalRef = modalRef;
        this._workflowService = _workflowService;
        this.sidebarNavService = sidebarNavService;
        this.translate = translate;
        this._workflowObservableService = _workflowObservableService;
        this._unsubscribeAll = new Subject();
        this.currentActiveMenuItem = { id: "", status: undefined, title: "", visible: false };
        this.id = 0;
        this.isLoading = false;
        this.isNew = true;
        this.metadata = undefined;
        this.workflowData = undefined;
        this.isDraftMode = undefined;
        this.stepperStatus = {
            'basic_details': 'in_progress',
            'custom_automation': 'pending'
        };
        this.viewMode = 'form';
    }
    AutomationSetupComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.onClose = new Subject();
                        if (!(!this.isNew && this.id > 0)) return [3 /*break*/, 2];
                        this.isLoading = true;
                        return [4 /*yield*/, this.getData()];
                    case 1:
                        _a.sent();
                        this.isLoading = false;
                        this.stepperStatus = {
                            basic_details: 'completed'
                        };
                        if (Object.keys(this.workflowData.dagSource).length === 0) {
                            this.stepperStatus['custom_automation'] = 'in_progress';
                        }
                        else {
                            this.stepperStatus['custom_automation'] = 'completed';
                        }
                        _a.label = 2;
                    case 2:
                        this.setSidebarMeta(this.stepperStatus);
                        this.sidebarNavService.setMetadata(this.sidebarMetadata);
                        this._workflowObservableService.workflowData$
                            .pipe(takeUntil(this._unsubscribeAll))
                            .subscribe({
                            next: function (data) {
                                _this.workflowData = data;
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AutomationSetupComponent.prototype.getData = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._workflowService.getWorkflowData(_this.id, 'custom_automation')
                .pipe(takeUntil(_this._unsubscribeAll))
                .subscribe({
                next: function (resp) {
                    console.log('resp', resp);
                    if (resp.hasOwnProperty('workflowData')) {
                        _this.workflowData = resp['workflowData'];
                        resolve(true);
                    }
                },
                error: function (err) {
                    console.error(err);
                    reject(false);
                }
            });
        });
    };
    AutomationSetupComponent.prototype.setSidebarMeta = function (stepsStatus) {
        if (stepsStatus === void 0) { stepsStatus = undefined; }
        this.sidebarMetadata = {
            showProgressBar: true,
            items: [
                {
                    id: 'basic_details',
                    title: this.translate.instant('Basic.Details.Title'),
                    status: stepsStatus ? stepsStatus['basic_details'] : 'in_progress',
                    visible: true,
                },
                {
                    id: 'custom_automation',
                    title: this.translate.instant('Automation'),
                    status: stepsStatus ? stepsStatus['custom_automation'] : 'pending',
                    visible: true
                },
            ]
        };
    };
    AutomationSetupComponent.prototype.setCurrentActiveItem = function (e) {
        this.currentActiveMenuItem = e;
    };
    AutomationSetupComponent.prototype.closeModal = function () {
        this.onClose.next(true);
        this.modalRef.hide();
    };
    AutomationSetupComponent.prototype.ngOnDestroy = function () {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    };
    return AutomationSetupComponent;
}());
export { AutomationSetupComponent };
